"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.admin_partner = void 0;
var utils_1 = require("../../utils");
// [partner]
exports.admin_partner = function (axios) {
    return {
        getPartners: function (request) {
            return axios.get('/partners', __assign(__assign({}, request), { headers: { Version: '1.1' } }));
        },
        postPartners: function (request) {
            return axios.post('/partners', request.data);
        },
        getPartnersActive: function (request) {
            return axios.get('/partners/active', request);
        },
        getPartnersExists: function (request) {
            return axios.get('/partners/exists', request);
        },
        getPartnersActivePartnerNo: function (request) {
            var url = utils_1.paramPathchange('/partners/active/{partnerNo}', request);
            return axios.get(url);
        },
        postPartnersPartnerNoCopy: function (request) {
            var url = utils_1.paramPathchange('/partners/{partnerNo}/copy', request);
            return axios.post(url, request.data);
        },
        getPartnersInfoByNo: function (request) {
            var url = utils_1.paramPathchange('/partners/{partnerNo}', request);
            return axios.get(url);
        },
        putPartnersInfoByNo: function (request) {
            var url = utils_1.paramPathchange('/partners/{partnerNo}', request);
            return axios.put(url, request.data);
        },
        postPartnersPartnerNoResendEmail: function (request) {
            var url = utils_1.paramPathchange('/partners/{partnerNo}/resend-email', request);
            return axios.post(url, request.data);
        },
        deletePartnersPartnerNo: function (request) {
            var url = utils_1.paramPathchange('/partners/{partnerNo}', request);
            return axios.delete(url);
        },
        getPartnersTemp: function (request) {
            return axios.get('/partners/temp', request);
        },
        putPartnersTemp: function (request) {
            return axios.put('/partners/temp', request.data);
        },
        getPartnersByPartnerNo: function (request) {
            var url = utils_1.paramPathchange('/partners/{partnerNo}', request);
            return axios.get(url);
        },
        putPartnersByPartnerNo: function (request) {
            var url = utils_1.paramPathchange('/partners/{partnerNo}', request);
            return axios.put(url, request.data);
        },
        getPartnersMe: function () {
            var url = '/partners/me';
            return axios.get(url);
        },
        putPartnersPartnerNoMaster: function (request) {
            var url = utils_1.paramPathchange('/partners/{partnerNo}/master', request);
            return axios.put(url, request.data);
        }
    };
};
